import { render, staticRenderFns } from "./filter_characteristics.vue?vue&type=template&id=11ff9a4e"
import script from "./filter_characteristics.js?vue&type=script&lang=js&external"
export * from "./filter_characteristics.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports